import { GazetteerRecordParsed } from "../services/GazetteerService";

export class AddressHelper {
    static stringWithDash = (str: string | null | undefined) => (str ? `-${str}` : "");
    static getAddressLinesFromGazetteerRecord(gazetteerRecord: GazetteerRecordParsed): IAddressLines {
        if (gazetteerRecord) {
            let {
                STREET_DESCRIPTOR = "",
                SAO_START_NUMBER = "",
                SAO_END_NUMBER = "",
                SAO_START_SUFFIX = "",
                SAO_END_SUFFIX = "",
                PAO_START_NUMBER = "",
                PAO_START_SUFFIX = "",
                PAO_END_NUMBER = "",
                PAO_END_SUFFIX = "",
                PAO_TEXT = "",
                ORGANISATION = "",
                SAO_TEXT = "",
                LOCALITY_NAME = "",
            } = gazetteerRecord;

            if (STREET_DESCRIPTOR === null) {
                STREET_DESCRIPTOR = "";
            }
            if (SAO_START_NUMBER === null) {
                SAO_START_NUMBER = "";
            }
            if (SAO_END_NUMBER === null) {
                SAO_END_NUMBER = "";
            }
            if (SAO_START_SUFFIX === null) {
                SAO_START_SUFFIX = "";
            }
            if (SAO_END_SUFFIX === null) {
                SAO_END_SUFFIX = "";
            }
            if (PAO_START_NUMBER === null) {
                PAO_START_NUMBER = "";
            }
            if (PAO_START_SUFFIX === null) {
                PAO_START_SUFFIX = "";
            }
            if (PAO_END_NUMBER === null) {
                PAO_END_NUMBER = "";
            }
            if (PAO_END_SUFFIX === null) {
                PAO_END_SUFFIX = "";
            }
            if (PAO_TEXT === null) {
                PAO_TEXT = "";
            }
            if (ORGANISATION === null) {
                ORGANISATION = "";
            }
            if (SAO_TEXT === null) {
                SAO_TEXT = "";
            }
            if (LOCALITY_NAME === null) {
                LOCALITY_NAME = "";
            }

            const lines = [];
            const organisationUpperCased = ORGANISATION.toUpperCase();
            const saoTextUpperCased = SAO_TEXT.toUpperCase();
            const paoTextUpperCased = PAO_TEXT.toUpperCase();
            const sao = `${SAO_START_NUMBER}${SAO_START_SUFFIX}${AddressHelper.stringWithDash(SAO_END_NUMBER)}${SAO_END_SUFFIX}`.trim();
            const pao = `${PAO_START_NUMBER}${PAO_START_SUFFIX}${AddressHelper.stringWithDash(PAO_END_NUMBER)}${PAO_END_SUFFIX}`.trim();

            const addressLine1 = `${organisationUpperCased} ${saoTextUpperCased}`.trim();
            const addressLine2 = `${sao} ${paoTextUpperCased}`.trim();
            const defaultLine3 = `${pao} ${STREET_DESCRIPTOR}`.trim();

            addressLine1 && lines.push(addressLine1);
            addressLine2 && lines.push(addressLine2);
            defaultLine3 && lines.push(defaultLine3);
            if (lines.length < 3 && LOCALITY_NAME) {
                lines.push(LOCALITY_NAME);
            }

            const [line1, line2, line3] = lines;

            return { line1, line2, line3 };
        }
        return { line1: "", line2: "", line3: "" };
    }
}

interface IAddressLines {
    line1: string;
    line2: string;
    line3: string;
}
